import { render, staticRenderFns } from "./PhieuSuaChuaFormCuaHang.vue?vue&type=template&id=c28085ca&scoped=true&"
import script from "./PhieuSuaChuaFormCuaHang.vue?vue&type=script&lang=js&"
export * from "./PhieuSuaChuaFormCuaHang.vue?vue&type=script&lang=js&"
import style0 from "./PhieuSuaChuaFormCuaHang.vue?vue&type=style&index=0&id=c28085ca&style=true&media=print&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28085ca",
  null
  
)

export default component.exports